import { render, staticRenderFns } from "./dicom.vue?vue&type=template&id=4eb7c799&scoped=true&"
import script from "./dicom.vue?vue&type=script&lang=js&"
export * from "./dicom.vue?vue&type=script&lang=js&"
import style0 from "./dicom.vue?vue&type=style&index=0&id=4eb7c799&prod&scoped=true&lang=scss&"
import style1 from "./dicom.vue?vue&type=style&index=1&id=4eb7c799&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb7c799",
  null
  
)

export default component.exports